"use strict";

angular.module("vendor")
.controller("PaymentListController", function(
    $scope, $resource, PaymentService, VendorPaymentService, PaymentStatusFilterService, PaymentMethodsService, $stateParams
) {
    $scope.service = VendorPaymentService;
    $scope.paymentService = PaymentService;
    $scope.statusFilterService = PaymentStatusFilterService;
    $scope.methodChoicesLocalized = PaymentMethodsService.getMethodChoicesLocalized();

    this.exportData = function() {
        if ($scope.isExporting) {
            return;
        }

        $scope.isExporting = true;
        VendorPaymentService.exportData($scope.params).finally(function() {
            $scope.isExporting = false;
        });
    };
});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/payment/payment-list.controller.js
// module id = 1021
// module chunks = 0